import 'es6-shim'

// core
import React from 'react'
import ReactDOM from 'react-dom'

import { BrowserRouter as Router } from 'react-router-dom'

import { AppContainer } from 'react-hot-loader'

// Main component
import App from './App'

// Data store
import store from './js/stores/store'
import { Provider } from 'react-redux'

// // UI
import './css/pure.css'

export const WrappedApp = () => (
  <AppContainer>
    <Router>
      <Provider store={store}>
        <App />
      </Provider>
    </Router>
  </AppContainer>
)

// Hot Module Replacement API
if (module.hot) {
  const render = Component => {
    ReactDOM.render(
      <AppContainer>
        <Router>
          <Provider store={store}>
            <Component />
          </Provider>
        </Router>
      </AppContainer>, document.getElementById('App')
    )
  }

  module.hot.accept('./App', () => {
    const NewApp = require('./App').default
    render(NewApp)
  })

  render(App)
} else {
  ReactDOM.render(
    <WrappedApp />, document.getElementById('App')
  )
}



// WEBPACK FOOTER //
// /app/index.js